var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d45"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d45"] = parcelRequire;
}

var $ilpIi = parcelRequire("ilpIi");

var $33mat = parcelRequire("33mat");
parcelRequire("6AR8M");
const $d783a34d35d82b53$export$407ea409d1f3b539 = ()=>{
    return "_" + Math.random().toString(36).substr(2, 9);
};
function $d783a34d35d82b53$export$46df172d0127e4c5(doc) {
    return `
  <div class="home-testimonial">
    <svg viewBox="0 0 1024 1024" class="home-icon08">
      <path
        d="M225 448c123.712 0 224 100.29 224 224 0 123.712-100.288 224-224 224s-224-100.288-224-224l-1-32c0-247.424 200.576-448 448-448v128c-85.474 0-165.834 33.286-226.274 93.726-11.634 11.636-22.252 24.016-31.83 37.020 11.438-1.8 23.16-2.746 35.104-2.746zM801 448c123.71 0 224 100.29 224 224 0 123.712-100.29 224-224 224s-224-100.288-224-224l-1-32c0-247.424 200.576-448 448-448v128c-85.474 0-165.834 33.286-226.274 93.726-11.636 11.636-22.254 24.016-31.832 37.020 11.44-1.8 23.16-2.746 35.106-2.746z"
      ></path>
    </svg>
    <span class="home-text09">
      ${doc.content}
    </span>
    <div class="home-like-container">
      <div class="home-container13">
        <span id="your-stories-like-count" class="home-text10">
          <span class="home-text11">15</span>
          <span></span>
          <br />
        </span>
        <span class="home-text14">Likes</span>
      </div>
      <div class="home-container14">
        <button
          id="your-stories-like-btn"
          type="button"
          class="home-button5 button"
        >
          Like
        </button>
      </div>
    </div>
  </div>
  <div class="home-container15">
    <div class="home-container16">
      <img
        alt="profile"
        src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDE0fHxwb3J0cmFpdHxlbnwwfHx8fDE2MjYzNzg5NzI&amp;ixlib=rb-1.2.1&amp;w=200"
        id="your-user-image"
        class="home-image3"
      />
      <span id="your-stories-username" class="home-text15">
      ${doc.author}
      </span>
    </div>
  </div>`;
}


const $c9746ff7a56c2020$var$filterBtn = document.getElementById("filter-btn");
const $c9746ff7a56c2020$var$sortBtn = document.getElementById("sort-btn");
const $c9746ff7a56c2020$var$storyFormContainer = document.getElementById("story-UI-container");
const $c9746ff7a56c2020$var$contentContainer = document.getElementById("content-wrapper");
const $c9746ff7a56c2020$var$shareStoryBtn = document.getElementById("share-story-button");
const $c9746ff7a56c2020$var$dontSubmitStoryBtn = document.getElementById("dont-submit-story-btn");
const $c9746ff7a56c2020$var$accountLoginBtn = document.getElementById("login-logout-btn");
const $c9746ff7a56c2020$var$profilePageBtn = document.getElementById("profile-page-btn");
const $c9746ff7a56c2020$var$loader = document.getElementById("loader");
const $c9746ff7a56c2020$var$overlay = document.getElementById("overlay");
const $c9746ff7a56c2020$var$userStoryBtns = Array.from($c9746ff7a56c2020$var$contentContainer.querySelectorAll(".home-button6"));
const $c9746ff7a56c2020$var$userStoryBtnsRight = Array.from($c9746ff7a56c2020$var$contentContainer.querySelectorAll(".home-button7"));
// FILTER CONTENT
async function $c9746ff7a56c2020$var$filterContent() {
    const category = $c9746ff7a56c2020$var$filterBtn.value;
    try {
        const contentDocuments = [];
        const contentSnapshotRef = await (0, $ilpIi.getDocs)((0, $ilpIi.collection)((0, $33mat.firebaseDB), "content"));
        contentSnapshotRef.forEach((contentSnap)=>{
            const contentDocument = contentSnap.data();
            contentDocuments.push(contentDocument);
        });
        const filteredDocuments = contentDocuments.filter((document1)=>{
            if (category === "all") return document1;
            if (document1.category !== category) return document1.decade.toString() === category;
            else return document1.category === category;
        });
        $c9746ff7a56c2020$var$contentContainer.innerHTML = "";
        filteredDocuments.forEach((doc)=>{
            const contentElement = document.createElement("div");
            contentElement.classList.add("content-box");
            const html = ` 
      <div data-date=${doc.decade} class="home-timeline-l-container">
      <div class="home-year-container">
        <h2 class="home-text05 h2">${doc.decade}</h2>
      </div>
      <div class="home-line-container">
        <div class="home-line-container1">
          <img
            alt="Ellipse152915"
            src="public/external/ellipse192917-o77j-200h.png"
            class="home-ellipse15"
          />
          <div class="home-separator"></div>
        </div>
        <div class="home-image-container">
          <img
            alt="image"
            src="https://play.teleporthq.io/static/svg/default-img.svg"
            class="home-image2"
          />
        </div>
      </div>
      <div class="home-event-text-container">
        <div class="home-container12">
          <span class="home-text06">${doc.title}</span>
          <span class="home-text07">
          ${doc.content}
          </span>
        </div>
      </div>
      <button
      data-date=${doc.decade}
        type="button"
        class="home-button6 button"
      >
        User Stories in ${doc.decade}
      </button>
      </div>
      `;
            contentElement.innerHTML = html;
            $c9746ff7a56c2020$var$contentContainer.appendChild(contentElement);
        });
        // RE-ADD BUTTON FUNCTION TO DYNAMIC BUTTONS
        const userStoryBtns = Array.from($c9746ff7a56c2020$var$contentContainer.querySelectorAll(".home-button6"));
        userStoryBtns.forEach((btn)=>{
            btn.addEventListener("click", $c9746ff7a56c2020$var$renderUserStories);
        });
    } catch (error) {
        console.error("Error retrieving content:", error);
        alert("Failed to retrieve content. Please try again.");
    }
}
// SORT CONTENT
function $c9746ff7a56c2020$var$sortContent() {
    const isAscending = $c9746ff7a56c2020$var$sortBtn.classList.contains("asc");
    const order = isAscending ? "ascending" : "descending";
    isAscending ? $c9746ff7a56c2020$var$sortBtn.classList.remove("asc") : $c9746ff7a56c2020$var$sortBtn.classList.add("asc");
    const content = Array.from($c9746ff7a56c2020$var$contentContainer.querySelectorAll(".home-timeline-l-container"));
    content.sort((a, b)=>{
        const dateA = parseInt(a.dataset.date);
        const dateB = parseInt(b.dataset.date);
        if (order === "ascending") return dateA - dateB;
        else if (order === "descending") return dateB - dateA;
    });
    $c9746ff7a56c2020$var$contentContainer.innerHTML = "";
    content.forEach((data)=>$c9746ff7a56c2020$var$contentContainer.appendChild(data));
}
// RENDER STORIES
async function $c9746ff7a56c2020$var$renderUserStories(e) {
    const decadeFilter = parseInt(e.target.dataset.date);
    $c9746ff7a56c2020$var$overlay.style.display = "flex";
    const storiesContainer = document.getElementById("user-story-modal");
    storiesContainer.innerHTML = "";
    const header = document.createElement("h2");
    header.textContent = `Stories of the ${decadeFilter}`;
    header.classList.add("home-text08");
    header.id = "your-stories-left";
    storiesContainer.appendChild(header);
    const loader = document.createElement("div");
    loader.id = "loader";
    storiesContainer.appendChild(loader);
    try {
        const storiesSnapshot = await (0, $ilpIi.getDocs)((0, $ilpIi.collection)((0, $33mat.firebaseDB), "stories"));
        storiesContainer.removeChild(loader);
        const totalStories = [];
        storiesSnapshot.forEach((storyDoc)=>totalStories.push(storyDoc.data()));
        const filteredStories = totalStories.filter((story)=>{
            const decade = Math.floor(story.decade / 10) * 10;
            return decade === decadeFilter;
        });
        filteredStories.forEach((story)=>{
            const user = (0, $33mat.firebaseAuth).currentUser;
            // const isLikedByUser =
            // user && storyData.likedBy && storyData.likedBy.includes(user.uid);
            console.log(story);
            const storyElement = document.createElement("div");
            storyElement.classList.add("home-testimonial-card");
            storyElement.innerHTML = (0, $d783a34d35d82b53$export$46df172d0127e4c5)(story);
            storiesContainer.appendChild(storyElement);
        });
        // Add event listeners for like buttons
        const likeButtons = document.querySelectorAll(".like-button");
        likeButtons.forEach((likeButton)=>{
            likeButton.addEventListener("click", async (event)=>{
                const storyId = event.target.getAttribute("data-story-id");
                await handleLikeButton(storyId);
            });
        });
    } catch (error) {
        console.error("Error retrieving stories:", error);
        alert("Failed to retrieve stories. Please try again.");
    }
}
// DISPLAY USER STORY FORM
function $c9746ff7a56c2020$var$displayStoryForm() {
    $c9746ff7a56c2020$var$storyFormContainer.style.display = "flex";
}
// SUBMIT STORY
async function $c9746ff7a56c2020$var$submitYourStory(e) {
    e.preventDefault();
    const user = (0, $33mat.firebaseAuth).currentUser;
    if (!user) {
        alert("You need to be logged in to create a story.");
        return;
    }
    const title = document.getElementById("story-title").value;
    const content = document.getElementById("story-content").value;
    const date = document.getElementById("story-date-input").value;
    //   CONVERT INPUT TO JUST GET DECADE
    const selectedDate = new Date(date);
    const decade = selectedDate.getFullYear();
    const newStory = {
        title: title,
        content: content,
        date: date,
        decade: decade,
        author: user.displayName || "anon",
        likeCounter: 0,
        createdAt: new Date()
    };
    if (user) try {
        const storyRef = (0, $ilpIi.doc)((0, $33mat.firebaseDB), "stories", (0, $d783a34d35d82b53$export$407ea409d1f3b539)());
        await (0, $ilpIi.setDoc)(storyRef, newStory);
        alert("Story created successfully!");
    } catch (error) {
        console.error("Error creating story: ", error);
        alert("Failed to create story. Please try again.");
    }
    else alert("You need to be logged in to create a story.");
    $c9746ff7a56c2020$var$closeModal($c9746ff7a56c2020$var$storyFormContainer);
}
function $c9746ff7a56c2020$var$closeModal(element) {
    element.style.display = "none";
}
// CLOSE USER STORYS MODAL
$c9746ff7a56c2020$var$overlay.addEventListener("click", ()=>$c9746ff7a56c2020$var$closeModal($c9746ff7a56c2020$var$overlay));
$c9746ff7a56c2020$var$userStoryBtns.forEach((btn)=>btn.addEventListener("click", $c9746ff7a56c2020$var$renderUserStories));
$c9746ff7a56c2020$var$userStoryBtnsRight.forEach((btn)=>btn.addEventListener("click", $c9746ff7a56c2020$var$renderUserStories));
$c9746ff7a56c2020$var$dontSubmitStoryBtn.addEventListener("click", ()=>$c9746ff7a56c2020$var$closeModal($c9746ff7a56c2020$var$storyFormContainer));
$c9746ff7a56c2020$var$storyFormContainer.addEventListener("submit", $c9746ff7a56c2020$var$submitYourStory);
$c9746ff7a56c2020$var$shareStoryBtn.addEventListener("click", $c9746ff7a56c2020$var$displayStoryForm);
$c9746ff7a56c2020$var$filterBtn.addEventListener("change", $c9746ff7a56c2020$var$filterContent);
$c9746ff7a56c2020$var$sortBtn.addEventListener("click", $c9746ff7a56c2020$var$sortContent);


//# sourceMappingURL=index.f0fe4d69.js.map
